import { Paper, Typography } from '@mui/material/';
import Alert from '@mui/material/Alert';
import { infoMessage } from 'src/helpers/infoMessage';

export default function InfoBanner() {
  if (!infoMessage) return null;
  
  return (
    <Paper elevation={1} sx={{ p: '24px', height: '100%', width: '100%', margin: '8px', padding: '8px' }}>
      <Alert severity='info' sx={{ backgroundColor: 'white' }}>
        <Typography variant="h4">
          Vinsamlega athugið
        </Typography>
        <Typography>
          {infoMessage}
        </Typography>
      </Alert>
    </Paper>
  );
}
